import { useAnnouncementVideo } from '../../hooks/announcements/AnnouncementVideoContext'
import icons from '../../config/icons.config'
import AppIcon from '../icons/AppIcon'
import styles from './AnnouncementBanner.module.css'

interface AnnouncementBannerProps {
  id: string
  title: string
  link?: string
  videoUrl?: string
}

export default function AnnouncementBanner({ id, title, link, videoUrl }: AnnouncementBannerProps) {
  const { openAnnouncementVideo } = useAnnouncementVideo()

  function handleClick() {
    if (link) {
      window.open(link, '_blank')
      return
    }
    if (videoUrl) openAnnouncementVideo(id)
  }

  return (
    <button type="button" className={styles.banner} onClick={handleClick}>
      <span className={styles.icon}>
        <AppIcon icon={icons.megaphone} size={17} />
      </span>
      <span className={styles.text}>
        <b>{title}</b> is live
      </span>
      <span className={styles.chev}>
        <AppIcon icon={icons.right} size={16} />
      </span>
    </button>
  )
}
